import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';

// declare ga as a function to access the JS code in TS
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Cruize';

  constructor(private router: Router) {
    //without login UA-45108492-1
    //with login  UA-45108492-1
    
  //   this.addGAScript();
  //   this.router.events.pipe(
  //     filter(event => event instanceof NavigationEnd)
  //   ).subscribe((event: NavigationEnd) => {
  //     /** START : Code to Track Page View  */
  //     gtag('event', 'page_view', {
  //       page_path: event.urlAfterRedirects
  //     })
  //     /** END */
  //   })
  // }
  // /** Add Google Analytics Script Dynamically */
  // addGAScript() {
  //   let gtagScript: HTMLScriptElement = document.createElement('script');
  //   gtagScript.async = true;
  //   gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.GA_TRACKING_ID;
  //   document.head.prepend(gtagScript);
  //   /** Disable automatic page view hit to fix duplicate page view count  **/
  //   gtag('config', environment.GA_TRACKING_ID, { send_page_view: false });
  }

  ngOnInit(): void {
    var tagId = 'UA-45108492-1';
    if(sessionStorage.getItem("isAgentLoggedIn")) {
      tagId = 'UA-45108492-1';
    }
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
        gtag('config', tagId,
            {
                page_path: event.urlAfterRedirects
            }
        );
    });
  }
}
